// Import extend function.
import Component from '../../../js/core/component.js';

class FormValueList extends Component {

	_defaultSettings () {
		return {
			debug: false
		};
	}

	_init () {
		if (this.inited) {
			this._log('Value list is already inited');
			return;
		}

		this.inited = true;
	}

	initValueList (valueList) {
		const formItem = document.querySelector(`[data-value-list="${valueList.name}"]`);
		const control = formItem.querySelector('select, input');
		const controlType = control.nodeName;

		if (controlType === 'SELECT') {
			control.addEventListener('change', () => {
				this._executeValueListChange(valueList, control, controlType);
			});

			if (control.selectedIndex !== 0) {
				this._executeValueListChange(valueList, control, controlType);
			}
		}
		else {
			control.addEventListener('input', () => {
				this._executeValueListChange(valueList, control, controlType);
			});
		}

	}

	_executeValueListChange (valueList, control, controlType) {
		const data = valueList.values;
		let selectedVal = '';
		if (controlType === 'SELECT') {
			selectedVal = control.options[control.selectedIndex].text;
		}
		else {
			selectedVal = control.value;
		}
		let objectData = this._getMatchingData(selectedVal, data);

		if (objectData) {
			this._appendData(objectData, valueList.name);
		}
		else {
			return;
		}
	}

	_getMatchingData (selectedVal, data) {
		let matchingData;
		for (let i = 0; i < data.length; i++) {
			const item = data[i];

			if (item.name === selectedVal) {
				matchingData = item.data;
				break;
			}
			else if (item.name === 'no-match') {
				matchingData = item.data;
			}
		}

		return matchingData;
	}

	_appendData (objectData, controlName) {
		let fieldNames = Object.keys(objectData);

		fieldNames.forEach(fieldName => {
			let item;
			if (document.querySelector(`[data-name="${controlName}-${fieldName.toLowerCase()}"]`)) {
				item = document.querySelector(`[data-name="${controlName}-${fieldName.toLowerCase()}"]`);
			}
			else {
				return;
			}
			let dd = item.querySelector('dd');
			let input = item.querySelector(`[name="${fieldName}"]`);

			if (input) {
				input.value = objectData[fieldName];
				this._triggerEvent(input);
			}

			dd.innerHTML = objectData[fieldName];
			item.style.display = 'block';
		});
	}

	_triggerEvent (el) {
		// Trigger change event
		let event = new CustomEvent('input');
		el.dispatchEvent(event);
	}
}

export default FormValueList;



// WEBPACK FOOTER //
// ./components/form-elements/form/c-form-value-list.js